import React, { useEffect, useState, MouseEvent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Cookies from "js-cookie";
import "../../css/DashBoard.css";
import DashBoardNav from "../DashBoard/DashBoardNavComponent";
import { ApplicationState } from "../../store/index";
import { BASE_URL } from "../../variables/api";
import { useSelector } from "react-redux";

const StudentDashboardView: React.FC<any> = (props) => {
  const [fetchType, setFetchType] = useState<string>("Pending");
  const [itemsPerPage, setItemsPerPage] = useState<string>("10");
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [assessments, setAssessments] = useState<any[]>([]);
  const [filteredAssessments, setFilteredAssessments] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    itemsPerPage: "10",
  });
  const [loading, setLoading] = useState<boolean>(false);

  const toggleSideBar = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    $("body").toggleClass("sb-sidenav-toggled");
  };

  const user = useSelector((state: ApplicationState) => state.user);
  // console.log("User from Redux Store:", user);

  const userDropdown = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    $("#privateuserMenu").toggleClass("show");
  };

  const fetchStudentAssessments = (page: number = 1) => {
    setLoading(true);
    let url = `${BASE_URL}student/getStudentsAssessments.php?fetchType=${fetchType}&itemsPerPage=${itemsPerPage}&page=${page}`;

    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`;
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`;
    }

    axios
      .get(url)
      .then((response) => {
        // console.log("Student Assessments Response:", response.data);
        if (response.data.status === "success") {
          setAssessments(response.data.data.assessments || []);
          setPagination(response.data.data.pagination || {});
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching student assessments:", error);
        setLoading(false);
      });
  };

  const getStatusBadgeColor = (status: string) => {
    switch (status) {
      case "Pending":
        return "warning";
      case "Started":
        return "primary";
      case "Graded":
        return "success";
      case "Submitted":
        return "info";
      default:
        return "secondary";
    }
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleStartOrContinueAssessment = (assessment: any) => {
    const username = user?.Email || user?.userName || "";

    const currentDomain = window.location.origin;
    const examLinkUrl = `${currentDomain}/assessment?hash=${assessment.examlink}`;

    const storeCookieUrl = `${BASE_URL}include/storecookie.php?username=${encodeURIComponent(
      username
    )}&examLink=${encodeURIComponent(examLinkUrl)}`;

    window.open(storeCookieUrl, "_blank");
  };

  const handleViewGradedAssessment = async (assessment: any) => {
    const username = user?.Email || user?.userName || "";
    const currentDomain = window.location.origin;
    const gradingUrl = `${currentDomain}/assessmentViewComponent?id=${assessment.examlink}&exammode=gradingModeStudent&hash=${assessment.examlink}`;

    try {
      // Call gettesttoken endpoint to get the token
      const response = await axios.post(
        `${BASE_URL}externaluser/gettesttoken.php`,
        {
          examLink: assessment.examlink,
          username: username,
        }
      );

      if (response.data.status === "success" && response.data.data) {
        // Set the tokentest cookie with the value from the response
        Cookies.set("tokentest", response.data.data.tokentest, {
          expires: 1, // Cookie expires in 1 day
          path: "/",
        });

        // Set emaildomain cookie as well
        if (response.data.data.emaildomain) {
          Cookies.set("emaildomain", response.data.data.emaildomain, {
            expires: 1,
            path: "/",
          });
        }

        // Now open the graded assessment in a new tab
        window.open(gradingUrl, "_blank");
      } else {
        console.error("Failed to get token:", response.data);
        alert("Failed to authenticate. Please try again.");
      }
    } catch (error) {
      console.error("Error calling gettesttoken:", error);
      alert(
        "An error occurred while loading the assessment. Please try again."
      );
    }
  };

  // Filter assessments based on search query (client-side)
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredAssessments(assessments);
    } else {
      const filtered = assessments.filter((assessment: any) =>
        assessment.exam_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredAssessments(filtered);
    }
  }, [searchQuery, assessments]);

  useEffect(() => {
    $("#preloader").hide();
    fetchStudentAssessments(1);
  }, [fetchType, itemsPerPage, dateFrom, dateTo]);

  return (
    <React.Fragment>
      <DashBoardNav
        Logout={props.Logout}
        toggleSideBar={toggleSideBar}
        userDropdown={userDropdown}
      />

      <div id="layoutSidenav">
        <div id="layoutSidenav_content">
          <main>
            <div className="container-fluid">
              <div className="row mb-4 mt-4">
                <div className="col-12">
                  <h2 className="mb-4 fw-bold text-dark">
                    Pending Assessments Dashboard
                  </h2>

                  <div className="card border-0 shadow-sm student-dashboard-filter-card">
                    <div className="card-body p-4">
                      {/* Search Row */}
                      <div className="row mb-4">
                        <div className="col-12">
                          <div className="search-input-wrapper">
                            <input
                              type="text"
                              id="searchBar"
                              className="form-control filter-select"
                              placeholder="Search assessments..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <i className="fas fa-search search-icon-end"></i>
                          </div>
                        </div>
                      </div>

                      {/* Filters Row */}
                      <div className="row g-3">
                        <div className="col-lg-3 col-md-6 d-flex flex-column">
                          <label
                            htmlFor="statusFilter"
                            className="form-label filter-label mb-2"
                          >
                            Assessment Status
                          </label>
                          <select
                            id="statusFilter"
                            className="form-select filter-select"
                            value={fetchType}
                            onChange={(e) => setFetchType(e.target.value)}
                          >
                            <option value="Pending">Pending</option>
                            <option value="Started">Started</option>
                            <option value="Submitted">Submitted</option>
                            <option value="Graded">Graded</option>
                            <option value="all">All</option>
                          </select>
                        </div>

                        <div className="col-lg-3 col-md-6 d-flex flex-column">
                          <label
                            htmlFor="itemsPerPage"
                            className="form-label filter-label mb-2"
                          >
                            Items Per Page
                          </label>
                          <select
                            id="itemsPerPage"
                            className="form-select filter-select"
                            value={itemsPerPage}
                            onChange={(e) => setItemsPerPage(e.target.value)}
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="all">All</option>
                          </select>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <label
                            htmlFor="dateFrom"
                            className="form-label filter-label mb-2"
                          >
                            From Date
                          </label>
                          <input
                            type="date"
                            id="dateFrom"
                            className="form-control filter-select"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                          />
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <label
                            htmlFor="dateTo"
                            className="form-label filter-label mb-2"
                          >
                            To Date
                          </label>
                          <input
                            type="date"
                            id="dateTo"
                            className="form-control filter-select"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Assessments Cards */}
              <div className="row">
                <div className="col-12">
                  {loading ? (
                    <div className="text-center py-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        {/* <span className="visually-hidden">Loading...</span> */}
                      </div>
                    </div>
                  ) : assessments.length === 0 ? (
                    <div className="card border-0 shadow-sm text-center py-5 assessment-empty-card">
                      <div className="card-body">
                        <h5 className="text-muted">No assessments found</h5>
                        <p className="text-secondary">
                          There are no {fetchType.toLowerCase()} assessments at
                          the moment.
                        </p>
                      </div>
                    </div>
                  ) : filteredAssessments.length === 0 ? (
                    <div className="card border-0 shadow-sm text-center py-5 assessment-empty-card">
                      <div className="card-body">
                        <h5 className="text-muted">No assessments found</h5>
                        <p className="text-secondary">
                          No assessments match your search query "{searchQuery}
                          ".
                        </p>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="row g-4">
                        {filteredAssessments.map((assessment: any) => (
                          <div
                            key={assessment.id}
                            className="col-lg-4 col-md-6 col-12 mt-2 mb-2"
                          >
                            <div className="assessment-card">
                              <div className="assessment-card-header">
                                <h3 className="assessment-title">
                                  {assessment.exam_name}
                                </h3>
                                <span
                                  className={`badge assessment-badge bg-${getStatusBadgeColor(
                                    assessment.status
                                  )} text-white`}
                                >
                                  {assessment.status}
                                </span>
                              </div>

                              <div className="assessment-card-body">
                                <div className="assessment-info-row">
                                  <div className="assessment-info-item">
                                    <i className="fas fa-calendar-alt assessment-info-icon text-primary"></i>
                                    <div className="assessment-info-content">
                                      <div className="assessment-info-label">
                                        Released
                                      </div>
                                      <div className="assessment-info-value">
                                        {formatDate(assessment.releasedate)}
                                      </div>
                                    </div>
                                  </div>

                                  {assessment.submitdate && (
                                    <div className="assessment-info-item">
                                      <i className="fas fa-check-circle assessment-info-icon text-success"></i>
                                      <div className="assessment-info-content">
                                        <div className="assessment-info-label">
                                          Submitted
                                        </div>
                                        <div className="assessment-info-value">
                                          {formatDate(assessment.submitdate)}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {assessment.status === "Graded" &&
                                  assessment.total_score !== null &&
                                  assessment.total_score !== "" && (
                                    <div className="assessment-score-container">
                                      <i className="fas fa-trophy assessment-score-icon"></i>
                                      <div className="assessment-score-content">
                                        <div className="assessment-info-label">
                                          Your Score
                                        </div>
                                        <div className="assessment-score-display">
                                          <span className="assessment-score-value">
                                            {assessment.total_score}
                                          </span>
                                          <span className="assessment-score-separator">
                                            /
                                          </span>
                                          <span className="assessment-score-outof">
                                            {assessment.outof}
                                          </span>
                                          <span className="badge bg-primary assessment-score-percent text-white">
                                            {Math.round(
                                              (Number(assessment.total_score) /
                                                Number(assessment.outof)) *
                                                100
                                            )}
                                            %
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>

                              <div className="assessment-card-footer">
                                {assessment.status === "Pending" && (
                                  <button
                                    className="btn btn-primary assessment-action-btn w-100"
                                    onClick={() =>
                                      handleStartOrContinueAssessment(
                                        assessment
                                      )
                                    }
                                  >
                                    <i className="fas fa-play-circle"></i>
                                    <span>Start Assessment</span>
                                  </button>
                                )}
                                {assessment.status === "Started" && (
                                  <button
                                    className="btn btn-primary assessment-action-btn w-100"
                                    onClick={() =>
                                      handleStartOrContinueAssessment(
                                        assessment
                                      )
                                    }
                                  >
                                    <i className="fas fa-arrow-right"></i>
                                    <span>Continue Assessment</span>
                                  </button>
                                )}
                                {assessment.status === "Graded" && (
                                  <button
                                    className="btn btn-success assessment-action-btn w-100"
                                    onClick={() =>
                                      handleViewGradedAssessment(assessment)
                                    }
                                  >
                                    <i className="fas fa-eye"></i>
                                    <span>View Results</span>
                                  </button>
                                )}
                                {assessment.status === "Submitted" && (
                                  <button
                                    className="btn btn-outline-secondary assessment-action-btn w-100"
                                    disabled
                                  >
                                    <i className="fas fa-clock"></i>
                                    <span>Awaiting Grade</span>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Pagination */}
                      {pagination.totalPages > 1 && (
                        <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
                          <nav>
                            <ul className="pagination mb-0">
                              <li
                                className={`page-item ${
                                  pagination.currentPage === 1 ? "disabled" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    fetchStudentAssessments(
                                      pagination.currentPage - 1
                                    )
                                  }
                                  disabled={pagination.currentPage === 1}
                                >
                                  Previous
                                </button>
                              </li>

                              {[...Array(pagination.totalPages)].map(
                                (_, index) => (
                                  <li
                                    key={index + 1}
                                    className={`page-item ${
                                      pagination.currentPage === index + 1
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        fetchStudentAssessments(index + 1)
                                      }
                                    >
                                      {index + 1}
                                    </button>
                                  </li>
                                )
                              )}

                              <li
                                className={`page-item ${
                                  pagination.currentPage ===
                                  pagination.totalPages
                                    ? "disabled"
                                    : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    fetchStudentAssessments(
                                      pagination.currentPage + 1
                                    )
                                  }
                                  disabled={
                                    pagination.currentPage ===
                                    pagination.totalPages
                                  }
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </main>

          <footer className="py-4 bg-light mt-auto">
            <div className="container-fluid">
              <div className="d-flex align-items-center justify-content-between small">
                <div className="text-muted">
                  Copyright &copy; {props.schoolEnv?.fullname}{" "}
                  {new Date().getFullYear()}
                </div>
                <div>
                  <a id="Privacy" href="#Privacy">
                    Privacy Policy
                  </a>
                  &middot;
                  <a id="Terms" href="#Terms">
                    Terms &amp; Conditions
                  </a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
};

function mapStateToProps(state: ApplicationState) {
  return {
    schoolEnv: state.schoolEnv,
  };
}

export default withRouter(
  connect(mapStateToProps)(StudentDashboardView as any)
);
